import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./citizens-free-services-summaries.actions";
import * as fromGraphql from "./citizens-free-services-summaries.graphql"
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';

@Injectable()
export class CitizensFreeServicesSummariesEffects {

  citizenGetFreeServicesSummaries$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetFreeServicesSummaries),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_FREE_SERVICES_SUMMARIES,
        fetchPolicy: 'network-only',
        variables:{

        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching citizen Main Services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any =  data?.citizenGetFreeServicesSummaries
            result?.response?.status ? this.store.dispatch(fromActions.loadCitizensFreeServicesSummariess({ citizensFreeServicesSummariess: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
